import React from 'react';
import * as Yup from 'yup';
import { Field, Form, getIn, withFormik } from 'formik';
import { Card, Col, Row } from 'react-bootstrap';
import { FormikSelect } from '../../../components';

const ShiftFilters = ({ shifts, setFieldValue, errors, touched, isArial, selectPlaceHolder, submitForm }) => {
  const handleShiftChange = data => {
    setFieldValue('shift', data || null);
    if (data) {
      // Pequeño delay para asegurar que el valor se estableció
      setTimeout(() => {
        submitForm();
      }, 100);
    }
  };

  return (
    <>
      <Card className="mb-1 mt-2">
        <Col className="top-header-green">
          <Col className="card-header-title">Mis Turnos</Col>
        </Col>
        <Col sm={12} md={12} lg={12} className="mt-2">
          <Form className="shifts-filters">
            <Row>
              <Col sm={12} md={4} xs={12}>
                <Field name="shift">
                  {({ field }) => (
                    <FormikSelect
                      {...field}
                      abbr
                      label="Turnos"
                      options={shifts}
                      placeholder={selectPlaceHolder}
                      onChange={handleShiftChange}
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                      isArial={isArial}
                    />
                  )}
                </Field>
              </Col>
            </Row>
          </Form>
        </Col>
      </Card>
    </>
  );
};

const validationSchema = Yup.object().shape({
  shift: Yup.mixed().required('Debes seleccionar un Turno')
});

const setInitialValues = () => {
  return {
    shift: null
  };
};

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  try {
    const res = formRequest(values, setSubmitting);
    if (res && typeof res.then === 'function') {
      return res.finally(() => setSubmitting(false));
    }
    setSubmitting(false);
    return null;
  } catch (err) {
    setSubmitting(false);
    throw err;
  }
};

export default withFormik({
  mapPropsToValues: setInitialValues,
  validationSchema,
  handleSubmit,
  enableReinitialize: true
})(ShiftFilters);
